"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UPDATE_INVENTORY_ITEM = void 0;
var client_1 = require("@apollo/client");
exports.UPDATE_INVENTORY_ITEM = (0, client_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  mutation UpdateInventoryItem($input: UpdateInventoryItemInput!) {\n    updateInventoryItem(input: $input) {\n      inventoryItem {\n        id\n        quantity\n      }\n    }\n  }\n"], ["\n  mutation UpdateInventoryItem($input: UpdateInventoryItemInput!) {\n    updateInventoryItem(input: $input) {\n      inventoryItem {\n        id\n        quantity\n      }\n    }\n  }\n"])));
var templateObject_1;
